import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

type P = {
  open: boolean;
  onClose: () => void;
  onConfirm: (cancelVisitorRegistrations: boolean) => void;
};

export function ScheduleCancelConferenceVisitorsDialog({ open, onClose, onConfirm }: Readonly<P>) {
  const { t } = useTranslation();

  const handleDialogClose = (_event: object, reason: "backdropClick" | "escapeKeyDown") => {
    if (reason === "backdropClick") {
      return;
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      aria-labelledby="schedule-cancel-conference-visitors-title"
      data-testid="schedule-cancel-conference-visitors-dialog"
    >
      <DialogTitle
        id="schedule-cancel-conference-visitors-title"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
          pr: 1
        }}
      >
        {t("_schedule_cancelRoomAlsoCancelVisitorsTitle")}
        <IconButton
          aria-label={t("Close")}
          onClick={onClose}
          data-testid="schedule-cancel-conference-visitors-close"
          size="large"
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>{t("_schedule_cancelRoomAlsoCancelVisitorsBody")}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => onConfirm(false)}
          data-testid="schedule-cancel-conference-visitors-room-only"
          color="secondary"
        >
          {t("_schedule_cancelRoomAlsoCancelVisitorsNo")}
        </Button>
        <Button
          onClick={() => onConfirm(true)}
          variant="contained"
          color="error"
          data-testid="schedule-cancel-conference-visitors-yes"
        >
          {t("_schedule_cancelRoomAlsoCancelVisitorsYes")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
